import { haversineMiles } from '@numeo/types'
import type { BoxTruckVerification, NearbyBoxTruckDriver } from '../services/boxTruckLoadsApi'

/** A NearbyBoxTruckDriver row built from the tab's picked verification — shown when the nearby fetch
 *  can't supply the pinned driver itself. Best-effort fields; missing ones render as '—'. */
export const syntheticPinnedRow = (v: BoxTruckVerification, origin: { lat: number; lng: number } | null): NearbyBoxTruckDriver => {
    const loc = v.lastLocation ?? null
    const info = v.boxTruckInfo?.info
    return {
        driverId: v.userId,
        claimDriverId: v.claimDriverId,
        name: info?.name || v.name || v.email,
        truckNumber: info?.truckNumber ?? null,
        equipment: info?.equipmentType ?? null,
        // Only the server's vehicle join can supply these; a pinned row is built from the verification
        // record, which is the driver's account rather than the vehicle they are seated on.
        equipmentCapabilities: null,
        cargoDimensions: info?.cargoDimensions ?? null,
        maxCargoWeightLbs: info?.maxCargoWeightLbs ?? null,
        city: loc?.city ?? v.profileLocation?.city ?? null,
        state: loc?.state ?? v.profileLocation?.state ?? null,
        postalCode: loc?.postalCode ?? null,
        phone: info?.phone ?? null,
        emergencyContactPhone: info?.emergencyContactPhone ?? null,
        // Client-side great-circle for a pinned driver the nearby query didn't return. These rows are
        // ordinary selectable rows, so resolveMilesOut CAN route this into Copy Load and {{miles_out}}
        // when no current route exists — hence the same 0.1 precision the server (driver-locations-repo)
        // and the location editor both use, rather than whole miles.
        proximityDistanceMi: origin && loc ? Math.round(haversineMiles(origin.lat, origin.lng, loc.lat, loc.lng) * 10) / 10 : null,
        lat: loc?.lat ?? null,
        lng: loc?.lng ?? null,
        lastSeenAt: loc?.fixAt ?? null,
        verified: v.boxTruckInfo?.enabled === true,
        availability: v.availability ?? null,
        teamNote: v.teamNote ?? null,
    }
}
